import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import useSearchParam from '@lib/hooks/useSearchParam';
import { IconName } from '@lib/components/Modal/enums';

type Props = {
  actions?: React.ReactNode[];
  icon?: IconName;
  isFilterApplied?: boolean;
  onResetFilter?: () => void;
  text: React.ReactNode;
  title: React.ReactNode;
};

export default function ListEmptyState({
  actions,
  icon = IconName.Cancel,
  isFilterApplied,
  onResetFilter,
  text,
  title,
}: Props) {
  const [searchQuery, setSearchQuery] = useSearchParam();
  const { t } = useTranslation();
  const isNoResults = !!searchQuery || isFilterApplied;
  const onBackBtnClick = () => {
    setSearchQuery('');
    if (onResetFilter) onResetFilter();
  };
  const emptyStateActions = [
    <Button
      buttonText={t('go-back')}
      buttonType={ButtonTypes.primaryFilled}
      key="back"
      leftIcon="arrow_back"
      onClick={onBackBtnClick}
    />,
  ];
  return isNoResults ? (
    <EmptyState
      actions={emptyStateActions}
      icon={IconName.SearchOff}
      text={t('no-results-found-text')}
      title={t('no-results-found')}
    />
  ) : (
    <EmptyState actions={actions} icon={icon} text={text} title={title} />
  );
}
